















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class'
import Responsavel from '@/model/resource/Responsavel'
import {Role} from '@/enums/Role'

@Component
export default class RenderCargaAction extends Vue {
  @Getter('auth/role') role!: Role
  @Prop({required: true}) model!: Responsavel

  Role = Role
}
